module.exports = __webpack_public_path__ + "assets/a8b59f9b177a895192bd172f95157f94.svg";